/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetAllSupplierIds$Params {
  supplierPrefix: string;
}

export function getAllSupplierIds(
  http: HttpClient,
  rootUrl: string,
  params: GetAllSupplierIds$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, getAllSupplierIds.PATH, 'get');
  if (params) {
    rb.path('supplierPrefix', params.supplierPrefix, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    }),
  );
}

getAllSupplierIds.PATH = '/service/v1/supplier/supplierids/{supplierPrefix}';
